import React from 'react'
import { useTranslation } from "react-i18next";
import Title from '../../../../Common/components/Title/Title';
import UniCards from '../../Components/UniCards/UniCards';

import "./uniesCY.css";

export default function UniesCY() {
    const { t } = useTranslation();
    return (
        <>
            <div className="universities-cy__title-container">
                <Title title={t("pages.universities.tabs.northCyprus")} />
            </div>
            <UniCards country='cy' />
        </>
    )
}